<template>
  <div v-if="dataOrders">
    <b-card title="Ingresa los datos">

      <!-- form -->
      <validation-observer ref="simpleRules">

        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="6">
              <b-form-group label="Clínica">
                <validation-provider
                  #default="{ errors }"
                  name="Clínica"
                  rules="required"
                >
                  <b-form-select
                    v-model="order.clinic_id"
                    :options="clinics"
                    :state="errors.length > 0 ? false : null"
                    @change="filterClinic"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Odontólogo">
                <validation-provider
                  #default="{ errors }"
                  name="Odontólogo"
                  rules="required"
                >
                  <b-form-select
                    v-model="order.dentist_id"
                    :options="dentists"
                    :state="errors.length > 0 ? false : null"
                    :disabled="[5].includes(userData.role_id)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Paciente">
                <validation-provider
                  #default="{ errors }"
                  name="Paciente"
                  rules="required"
                >
                  <b-input-group>
                    <!-- Select de pacientes -->
                    <b-form-select
                      v-model="order.patient_id"
                      :options="patients"
                      :state="errors.length > 0 ? false : null"
                    />
                    <!-- Botón para agregar un paciente -->
                    <b-input-group-append>
                      <b-button
                        variant="primary"
                        title="Puedes crear un paciente"
                        @click="createNewPatientModal = true"
                      >
                        <feather-icon icon="PlusIcon" />
                        Nuevo
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col
              cols="6"
            >
              <b-form-group label="Tipo de trabajo">
                <validation-provider
                  #default="{ errors }"
                  name="Tipo de trabajo"
                  rules="required"
                >
                  <b-form-select
                    v-model="order.work_type_id"
                    :state="errors.length > 0 ? false : null"
                    :options="workTypes"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Hallazgos">
                <validation-provider
                  #default="{ errors }"
                  name="Hallazgos"
                  rules="required"
                >
                  <b-form-textarea
                    v-model="order.findings"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Le hace falta x dientes, tiene prótesis, mordida cruzada, etc..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Objetivos">
                <validation-provider
                  #default="{ errors }"
                  name="Objetivos"
                  rules="required"
                >
                  <b-form-textarea
                    v-model="order.objectives"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Corregir apiñamiento en arco superior e inferior, mejorar overjet y overbite, lograr relación molar bilateral en clase 1, mantener relaciones caninas bilateral en clase 1, etc..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col
              v-if="selectedClinic"
              md="12"
            >
              <b-card
                no-body
                class="card-apply-job mb-0"
              >
                <b-card-header class="pb-1 pt-0">

                  <p class="mb-0">
                    Dirección de entrega
                  </p>

                </b-card-header>

                <div class="apply-job-package bg-light-primary rounded">
                  <b-media no-body>
                    <b-media-body>
                      <h5 class="mb-0">
                        {{ selectedClinic[0].clinic_detail.address }}
                      </h5>
                      <small class="text-muted">
                        {{ selectedClinic[0].clinic_detail.city.name }}, {{ selectedClinic[0].clinic_detail.department.name }}
                      </small>
                    </b-media-body>
                  </b-media>

                  <!--                  <b-button
                  >
                    Cambiar
                  </b-button>-->

                </div>

              </b-card>

            </b-col>

            <!--            <b-col md="4">
              <b-form-group label="Dirección de entrega">
                <b-form-input
                  v-model="order.business_address"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Departamento">
                <b-form-select
                  v-model="selectedDepartment"
                  :options="filteredDepartments"
                  @change="filterCities"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Ciudad">
                <b-form-select
                  v-model="selectedCity"
                  :options="filteredCities"
                  :disabled="!selectedDepartment"
                />
              </b-form-group>
            </b-col>-->

            <b-col md="6">
              <b-form-group label="Fecha de entrega">
                <validation-provider
                  #default="{ errors }"
                  name="Fecha de entrega"
                  rules="required"
                >
                  <b-form-input
                    v-model="order.delivery_date"
                    type="date"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="RX Panorámica (Imagen, pdf)">
                <validation-provider
                  #default="{ errors }"
                  name="RX Panorámica"
                  rules="required"
                >

                  <b-form-file
                    v-model="order.rx_panorama_url"
                    accept="image/*, .pdf"
                    :state="errors.length > 0 ? false : null"
                    browse-text="Adjuntar"
                    drop-placeholder="Arrastra los archivos aqui..."
                    placeholder="Selecciona o arrastra los archivos..."
                    multiple
                    @change="onFileChange($event, 'rx_panorama_url')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Fotos Intraorales (Imagen, pdf)">
                <validation-provider
                  #default="{ errors }"
                  name="Fotos Intraorales"
                  rules="required"
                >
                  <b-form-file
                    v-model="order.intraoral_photos_url"
                    accept="image/*, .pdf"
                    :state="errors.length > 0 ? false : null"
                    browse-text="Adjuntar"
                    placeholder="Selecciona o arrastra los archivos..."
                    multiple
                    @change="onFileChange($event, 'intraoral_photos_url')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Escaneo Intraoral (Archivo ZIP)">
                <validation-provider
                  #default="{ errors }"
                  name="Escaneo Intraoral"
                  rules="required"
                >
                  <b-form-file
                    v-model="order.intraoral_scan_url"
                    accept=".zip"
                    :state="errors.length > 0 ? false : null"
                    browse-text="Adjuntar"
                    placeholder="Selecciona el archivo..."
                    @change="onFileChange($event, 'intraoral_scan_url')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-button
                :disabled="loading"
                :variant="loading ? 'secondary' : 'success'"
                type="submit"
              >
                <b-spinner
                  v-if="loading"
                  small
                  class="mr-2"
                />
                {{ loading ? 'Creando...' : 'Registrar pedido' }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>

      </validation-observer>

    </b-card>

    <b-modal
      v-model="createNewPatientModal"
      centered
      title="Crear paciente"
      size="lg"
      hide-footer
    >

      <create-users-card
        class="mt-2"
        @close-modal="getDataCreate"
      />

    </b-modal>

    <b-modal
      v-model="loading"
      centered
      title="Subiendo archivos"
      size="lg"
      hide-footer
    >

      <div class="progress-wrapper">
        <b-card-text class="">
          El proceso puede tardar unos minutos mientras se suben los archivos. Por favor, espera un momento y asegúrate de que la carga se complete correctamente antes de continuar.
        </b-card-text>
        <br>
        <b-card-text class="mb-0">
          No recargues la página.
        </b-card-text>

        <b-progress
          v-model="progress"
          class="mt-1 mb-2"
          max="100"
          animated
        />
        <!--        <b-button @click="startProcess">Iniciar proceso</b-button>
        <b-button @click="completeProcess">Finalizar proceso</b-button>-->
      </div>

    </b-modal>

  </div>

  <loading-skeleton v-else />

</template>

<script>
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import {
  BFormInput,
  BRow,
  BCol,
  BFormGroup,
  BCardText,
  BButton,
  BCard,
  BForm,
  BFormSelect,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormTextarea,
  BFormFile,
  BSpinner, BMediaAside, BMedia, BCardHeader, BAvatar, BBadge, BMediaBody, BModal, BImg, BProgress,
} from 'bootstrap-vue'
import { required } from '@validations'
import api from '@/plugin/axios'
import CreateUsersCard from '@/views/admin/users/create/CreateUsersCard.vue'
import LoadingSkeleton from '@/views/misc/LoadingSkeleton.vue'

export default {
  components: {
    BProgress,
    LoadingSkeleton,
    CreateUsersCard,
    BImg,
    BModal,
    BMediaBody,
    BBadge,
    BAvatar,
    BCardHeader,
    BMedia,
    BMediaAside,
    BSpinner,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BForm,
    BFormSelect,
    BFormTextarea,
    BFormFile,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
  },
  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      value: 50,
      order: {
        clinic_id: '',
        dentist_id: '',
        patient_id: '',
        work_type_id: '',
        delivery_date: '',
        findings: '',
        objectives: '',
        business_address: '',
        city_id: '',
        department_id: '',
        rx_panorama_url: null,
        intraoral_photos_url: null,
        intraoral_scan_url: null,
      },
      clinics: [],
      dentists: [],
      patients: [],
      cities: [],
      departments: [],
      selectedDepartment: null,
      selectedCity: null,
      filteredDepartments: [],
      filteredCities: [],
      loading: false,
      selectedClinic: null,
      dataOrders: null,
      workTypes: [
        { value: 1, text: 'Planificación' },
        { value: 2, text: 'Refinamiento' },
      ],
      userData: JSON.parse(localStorage.getItem('userData')),
      createNewPatientModal: false,

      progress: 0,
      interval: null,
      maxProgress: 80,
      processFinished: false,
    }
  },
  async created() {
    this.getDataCreate()
  },
  methods: {
    async getDataCreate() {
      [this.dataOrders] = await Promise.all([
        api.get('/api/orders/create'),
      ])

      this.createNewPatientModal = false
      this.cities = this.dataOrders.data.cities.map(city => ({ value: city.id, text: city.name, department_id: city.department_id }))
      this.departments = this.dataOrders.data.departments.map(dep => ({ value: dep.id, text: dep.name, country_id: dep.country_id }))
      this.filteredDepartments = this.departments
      this.clinics = this.dataOrders.data.clinics.map(clinic => ({ value: clinic.clinic_detail.id, text: clinic.first_name }))

      this.dentists = this.dataOrders.data.dentists.map(dentist => ({ value: dentist.id, text: dentist.full_name }))

      console.log(this.dentists, this.userData.id)
      if (this.userData.role_id === 5) {
        this.order.dentist_id = this.userData.id // Forzar selección de "Paciente"
        this.dentists = this.dentists.filter(dentists => dentists.value === this.userData.id)
      }

      this.patients = this.dataOrders.data.patients.map(patient => ({ value: patient.id, text: `${patient.full_name} - ${patient.document_type}: ${patient.document_number}` }))
    },

    onFileChange(event, field) {
      this.order[field] = event.target.files[0]
      console.log(this.order[field])
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          this.loading = true
          const formData = new FormData()
          // eslint-disable-next-line guard-for-in
          for (const key in this.order) {
            formData.append(key, this.order[key])
          }

          // Archivos múltiples
          this.order.rx_panorama_url.forEach((file, index) => {
            formData.append('rx_panorama_url[]', file)
          })

          this.order.intraoral_photos_url.forEach((file, index) => {
            formData.append('intraoral_photos_url[]', file)
          })

          this.startProcess()
          this.order.department_id = this.selectedDepartment
          this.order.city_id = this.selectedCity
          this.order.role_id = 6 // role_id = 6 Clinica
          try {
            const response = await api.post('/api/orders', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            this.$bvToast.toast('Pedido registrado con éxito', {
              title: '¡Satisfactoriamente!', // Título del toast
              variant: 'success', // Color del toast
              solid: true, // Hace que el toast no sea translúcido
              autoHideDelay: 5000, // Duración en milisegundos (opcional)
              appendToast: true, // Asegura que se muestre como el más reciente
            })

            console.log(response)

            this.$router.push({ name: 'admin-orders' })

            /*if (this.userData.role_id === 5) {
              this.$router.push({ name: 'admin-checkout', params: { id: response.data.planning_order.id, payment_type: 'planificacion' } })
            } else {
              this.$router.push({ name: 'admin-orders' })
            }*/
          } catch (error) {
            console.log('loading', error)
            if (error.response && error.response.data.errors) {
              const messages = Object.values(error.response.data.errors).flat().join('\n')

              this.$bvToast.toast(messages, {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            } else {
              this.$bvToast.toast('Ocurrió un error inesperado', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            }
          } finally {
            this.loading = false
            this.completeProcess()
          }
        }
      }).catch(err => {
        this.loading = false
        const { errors } = this.$refs.simpleRules

        // Si quieres ver qué campo tiene el error
        for (const error of errors) {
          console.log(`Campo: ${error.field}, Error: ${error.msg}`)
        }
      })
    },
    filterDepartments() {
      this.selectedDepartment = null
      this.selectedCity = null
      this.filteredDepartments = this.departments.filter(dep => parseInt(dep.country_id, 10) === this.selectedCountry)
      this.filteredCities = []
    },
    filterCities() {
      this.selectedCity = null
      this.filteredCities = this.cities.filter(city => parseInt(city.department_id, 10) === this.selectedDepartment)
    },
    filterClinic() {
      this.selectedClinic = this.dataOrders.data.clinics.filter(clinic => clinic.clinic_detail.id === this.order.clinic_id)
      console.log(this.selectedClinic, this.order.clinic_id)
      this.order.business_address = this.selectedClinic[0].clinic_detail.address
      this.order.city_id = this.selectedClinic[0].clinic_detail.city.id
      this.order.department_id = this.selectedClinic[0].clinic_detail.department.id
    },
    startProcess() {
      this.progress = 0
      this.processFinished = false

      // Incremento aleatorio en 60s hasta un máximo del 70%
      this.interval = setInterval(() => {
        if (this.progress < this.maxProgress) {
          this.progress += Math.floor(Math.random() * 5) + 1 // Incremento aleatorio de 1 a 5
          if (this.progress > this.maxProgress) {
            this.progress = this.maxProgress // No superar el 70%
          }
        }
      }, 1000)

      // Detener después de 60 segundos
      setTimeout(() => {
        clearInterval(this.interval)
      }, 60000)
    },
    completeProcess() {
      clearInterval(this.interval) // Detiene la actualización del progreso

      if (this.progress < this.maxProgress) {
        // Si no llegó al 70%, completar desde donde quedó
        this.progress = 100
      } else {
        // Si ya alcanzó el 70%, completar el 30% restante
        const remaining = 100 - this.progress
        const step = remaining / 10 // Para una animación más suave

        const completeInterval = setInterval(() => {
          this.progress += step
          if (this.progress >= 100) {
            this.progress = 100
            clearInterval(completeInterval)
          }
        }, 100)
      }

      this.processFinished = true
    },
  },
}
</script>
